/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const Wallet = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      width="19px"
      height="16px"
      viewBox="0 0 19 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      {...props}
      data-palette="Wallet">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="New-Layout-v2-Copy"
          transform="translate(-1319.000000, -52.000000)"
          fillRule="nonzero"
        >
          <g id="Group-21" transform="translate(1314.000000, 46.000000)">
            <circle id="Oval-7" cx="14" cy="14" r="14" />
            <g
              id="noun_Wallet_85011"
              transform="translate(5.000000, 6.000000)"
              fill="#FFFFFF"
            >
              <g id="Group">
                <path
                  d="M18.3309859,7.40338983 C18.0633803,7.40338983 17.8492958,7.62033898 17.8492958,7.89152542 L17.8492958,10.0610169 C17.8492958,10.1966102 17.7957746,10.2779661 17.7690141,10.3050847 C17.6084507,10.4677966 17.2070423,10.4949153 17.0197183,10.4949153 L12.7380282,10.4949153 C11.9084507,10.4949153 11.2126761,9.76271186 11.2126761,8.86779661 C11.2126761,7.97288136 11.8816901,7.24067797 12.7380282,7.24067797 L15.8422535,7.24067797 C15.8957746,7.24067797 16.3774648,7.29491525 16.7788732,6.91525424 C17.1267606,6.58983051 17.3140845,6.10169492 17.3140845,5.45084746 L17.3140845,4.1220339 C17.3140845,3.30847458 16.671831,2.65762712 15.8690141,2.65762712 L1.49859155,2.65762712 C1.25774648,2.65762712 1.04366197,2.38644068 1.04366197,2.08813559 L1.04366197,1.97966102 C1.04366197,1.00338983 1.31126761,1.00338983 1.52535211,1.00338983 L14.9323944,1.00338983 C15.2,1.00338983 15.4140845,1.22033898 15.4140845,1.49152542 C15.4140845,1.76271186 15.628169,1.97966102 15.8957746,1.97966102 C16.1633803,1.97966102 16.3774648,1.76271186 16.3774648,1.49152542 C16.3774648,0.677966102 15.7352113,0.0271186441 14.9323944,0.0271186441 L1.52535211,0.0271186441 C0.561971831,0.0271186441 0.0802816901,0.677966102 0.0802816901,1.97966102 L0.0802816901,2.08813559 L0.0802816901,14.3186441 C0.0802816901,15.1322034 0.722535211,15.7830508 1.52535211,15.7830508 L15.8422535,15.7830508 C16.6450704,15.7830508 17.2873239,15.1322034 17.2873239,14.3186441 L17.2873239,11.4711864 C17.6084507,11.4440678 18.0901408,11.3627119 18.4380282,11.0101695 C18.7056338,10.7661017 18.8394366,10.440678 18.8394366,10.0338983 L18.8394366,7.86440678 C18.8126761,7.62033898 18.5985915,7.40338983 18.3309859,7.40338983 Z M15.8422535,14.779661 L1.52535211,14.779661 C1.25774648,14.779661 1.04366197,14.5627119 1.04366197,14.2915254 L1.04366197,3.63389831 L15.8422535,3.63389831 C16.1098592,3.63389831 16.3239437,3.85084746 16.3239437,4.1220339 L16.3239437,5.45084746 C16.3239437,5.80338983 16.243662,6.07457627 16.1366197,6.18305085 C16.0295775,6.26440678 15.9225352,6.26440678 15.8957746,6.26440678 L12.7380282,6.26440678 C11.3732394,6.26440678 10.2492958,7.43050847 10.2492958,8.86779661 C10.2492958,10.3050847 11.3732394,11.4711864 12.7380282,11.4711864 L16.3239437,11.4711864 L16.3239437,14.2915254 C16.3239437,14.5627119 16.1098592,14.779661 15.8422535,14.779661 Z"
                  id="Shape"
                />
                <ellipse id="Oval" cx="12.8985915" cy="8.86779661" rx="1" ry="1" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default Wallet;
